import React from "react";
import { FaStar, FaBuilding, FaUser, FaTrophy } from "react-icons/fa";

const BuilderCard = () => {
  const builders = [
    {
      id: 1,
      logo: "/logo1.avif", // Sample logo image
      name: "Prime Builders",
      rating: 4.5,
      experience: 15, // Years of experience
      projects: 120, // Number of projects completed
      about: "Prime Builders have been shaping skylines for over 15 years with high-quality residential and commercial projects.",
    },
    {
      id: 2,
      logo: "/logo2.jpg", // Sample logo image
      name: "Urban Developments",
      rating: 4.8,
      experience: 10,
      projects: 75,
      about: "Urban Developments specializes in modern, sustainable housing solutions and urban revitalization projects.",
    },
    {
      id: 3,
      logo: "/logo3.jpg", // Sample logo image
      name: "Green Horizon Builders",
      rating: 4.3,
      experience: 20,
      projects: 150,
      about: "With a focus on eco-friendly construction, Green Horizon Builders is known for building homes that blend seamlessly with nature.",
    },
  ];

  return (
    <div className="p-6">
      <div className="flex flex-wrap gap-6 justify-center">
        {builders.map((builder) => (
          <div
            key={builder.id}
            className="relative bg-white shadow-md rounded-lg w-80 p-6 border-l-4 hover:shadow-xl hover:border-blue-600 transition duration-300 ease-in-out"
          >
            <div
              className="absolute top-0 left-0 w-full h-2 rounded-t-lg"
              style={{ backgroundColor: "#36A2EB" }}
            ></div>

            {/* Builder Logo */}
            <div className="rounded-lg overflow-hidden mb-4 flex justify-center">
              <img
                src={builder.logo}
                alt={builder.name}
                className="w-24 h-24 object-cover rounded-full"
              />
            </div>

            {/* Builder Details */}
            <h2 className="text-lg font-bold text-gray-800 mb-2 text-center">{builder.name}</h2>

            <div className="text-center mb-4 flex items-center justify-center text-yellow-500">
              {[...Array(5)].map((_, i) => (
                <FaStar key={i} className={i < builder.rating ? "text-yellow-500" : "text-gray-300"} />
              ))}
              <span className="ml-2 text-gray-600">{builder.rating} Stars</span>
            </div>

            {/* Builder Info Cards */}
            <div className="flex flex-col justify-between items-center mb-4 gap-3">
              <div className="flex justify-center items-center bg-blue-100 text-blue-600 p-2 rounded-lg shadow-md gap-1">
                <FaTrophy size={12} />
                <span className="text-sm font-semibold">{builder.experience} years experience</span>
              </div>

              <div className="flex justify-center items-center bg-green-100 text-green-600 p-2 rounded-lg shadow-md gap-1">
                <FaBuilding size={12} />
                <span className="text-sm font-semibold">{builder.projects} projects</span>
              </div>
            </div>

            {/* About the Builder */}
            <p className="text-sm text-gray-600 italic mb-4 text-center">
              {builder.about}
            </p>

            {/* Buttons */}
            <div className="flex gap-4 mt-4">
              <button className="flex-1 bg-primaryOrange text-white text-sm font-semibold py-2 px-4 rounded-lg hover:bg-orange-600 transition">
                View Profile
              </button>
              <button className="flex-1 bg-gray-100 text-gray-700 text-sm font-semibold py-2 px-4 rounded-lg hover:bg-gray-800 hover:text-white transition">
                Contact Builder
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BuilderCard;
